import { Heading } from '@chakra-ui/react';
import HPXModulesManagementDataTableHandler from '../../containers/dataTableHandlers/base/hpxModulesManagement/HPXModulesManagementDataTableHandler';

const HPXModulesManagementPage = () => {
  return (
    <>
      <Heading size="md" mb={"2rem"}>HPX Modules Management</Heading>
      <HPXModulesManagementDataTableHandler />
      {/* <HPXModulesManagementFormHandle /> */}
    </>
  )
}

export default HPXModulesManagementPage